export default __webpack_public_path__ + "img/9a5ab0a9db703044377dd7feeff48a48.svg";